import type {
  IngredientFilterV2,
  IngredientSelectionParamsV2,
  IngredientSelectionParams,
  IngredientFilter,
} from "@shared/components/CatalogSearch/CatalogSearch";

import { useCatalogSearch } from "../useCatalogSearch/useCatalogSearch";

const useHandleIngredientSelect = () => {
  const { activeIngredients, setActiveIngredients, excludedIngredients, setExcludedIngredients } =
    useCatalogSearch();

  const callback = (ingredientSelectOptions: IngredientSelectionParams, isExcluded = false) => {
    const { ingredientSelected, symbol, dosage, unit, subTypeSelected } = ingredientSelectOptions;

    const newFilter: IngredientFilter = {
      ...ingredientSelected,
      searchAttributes: {
        ...ingredientSelected.searchAttributes,
        addon: { dose: dosage || 0, symbol: symbol || "gte", unit },
      },
    };

    const ingredientsArray = isExcluded ? excludedIngredients : activeIngredients;

    const existingIngredientIndex = ingredientsArray.findIndex(
      ingredient => ingredient.name === ingredientSelected.name
    );

    const newIngredients = [...ingredientsArray];
    if (existingIngredientIndex > -1) {
      newIngredients[existingIngredientIndex] = subTypeSelected || newFilter;
    } else {
      newIngredients.push(newFilter);
    }

    isExcluded ? setExcludedIngredients(newIngredients) : setActiveIngredients(newIngredients);
  };

  const callbackV2 = (
    ingredientSelectOptions: IngredientSelectionParamsV2,
    scopedActiveIngredients: IngredientFilterV2[],
    isExcluded = false
  ) => {
    const { ingredientSelected, minDose, maxDose, unit } = ingredientSelectOptions;

    const newFilter = {} as IngredientFilterV2;
    newFilter.name = ingredientSelected.name;

    newFilter.searchAttributes = {
      id: ingredientSelected.searchAttributes.id,
    };

    if (minDose || maxDose || unit) {
      newFilter.searchAttributes.addon = {
        ...(minDose && { minDose }),
        ...(maxDose && { maxDose }),
        ...(unit && { unit }),
      };
    }

    const ingredientsArray: IngredientFilterV2[] = isExcluded
      ? excludedIngredients
      : scopedActiveIngredients;

    const existingIngredientIndex = ingredientsArray.findIndex(
      ingredient => ingredient.name === ingredientSelected.name
    );

    const newIngredients = [...ingredientsArray];
    if (existingIngredientIndex > -1) {
      newIngredients[existingIngredientIndex] = newFilter;
    } else {
      newIngredients.push(newFilter);
    }

    isExcluded ? setExcludedIngredients(newIngredients) : setActiveIngredients(newIngredients);
  };

  return {
    handleIngredientSelection: callback,
    handleIngredientSelectionV2: callbackV2,
  };
};

export { useHandleIngredientSelect };
